import hideTooltips from './hide-tooltips';

export default {
  hideTooltips,
};
